import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

const BASE = `${config.API_URL}Beacon4PerformanceNetworkOverview/admin`;

// ── KPI Configs ─────────────────────────────────────────────────────────────
export const ListBeacon4PerfConfigs = (params) =>
	AxiosRequest({ method: 'GET', url: `${BASE}/kpis`, params });

export const GetBeacon4PerfConfig = (id) =>
	AxiosRequest({ method: 'GET', url: `${BASE}/kpis/${id}` });

export const CreateBeacon4PerfConfig = (data) =>
	AxiosRequest({ method: 'POST', url: `${BASE}/kpis`, data });

export const UpdateBeacon4PerfConfig = (id, data) =>
	AxiosRequest({ method: 'PUT', url: `${BASE}/kpis/${id}`, data });

export const DeleteBeacon4PerfConfig = (id, note) =>
	AxiosRequest({ method: 'DELETE', url: `${BASE}/kpis/${id}`, params: { note } });

export const ValidateBeacon4PerfSql = (data) =>
	AxiosRequest({ method: 'POST', url: `${BASE}/kpis/validate-sql`, data });

// ── Mappings ────────────────────────────────────────────────────────────────
export const ListBeacon4PerfMappings = (mainKpiId) =>
	AxiosRequest({ method: 'GET', url: `${BASE}/mappings`, params: { mainKpiId } });

export const CreateBeacon4PerfMapping = (data) =>
	AxiosRequest({ method: 'POST', url: `${BASE}/mappings`, data });

export const UpdateBeacon4PerfMapping = (id, data) =>
	AxiosRequest({ method: 'PUT', url: `${BASE}/mappings/${id}`, data });

export const DeleteBeacon4PerfMapping = (id, note) =>
	AxiosRequest({ method: 'DELETE', url: `${BASE}/mappings/${id}`, params: { note } });

// ── Audit ───────────────────────────────────────────────────────────────────
export const ListBeacon4PerfAudit = (table, id) =>
	AxiosRequest({ method: 'GET', url: `${BASE}/audit/${table}/${id}` });

export const RollbackBeacon4PerfAudit = (auditId, note) =>
	AxiosRequest({ method: 'POST', url: `${BASE}/audit/${auditId}/rollback`, data: { note } });
